var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('principal-layout'),_c('modal-cupo'),(_vm.$route.matched[0]?.name !== 'legalesPage')?_c('button-whatsapp'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }